<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="roomClosureForm">
        <div class="mt-5">
            <div class="form-row">
              <div class="col-md-6 mb-3">
                <label for="office">Office</label>
                <select id="office" class="form-control" formControlName="office">
                  <option *ngFor="let office of offices" [value]="office.id">
                    {{ office.city + ', ' + office.address }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 mb-3">
                <label for="roomId">Room</label>
                <select id="roomId" class="form-control" formControlName="roomId">
                  <option *ngFor="let room of rooms" [value]="room.id">
                    {{ room.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6 mb-3">
                <label for="start">Start</label>
                <app-date-time-picker id="start" formControlName="start" name="start" [seconds]="false" [disabled]="true"></app-date-time-picker>
                <div class="text-danger" *ngIf="roomClosureForm.get('start').errors?.required">Start is required.</div>
                <div class="text-danger" *ngIf="roomClosureForm.get('start')?.value && roomClosureForm.get('start')?.errors?.isValid">Start Date must be a valid date.</div>
              </div>
              <div class="col-md-6 mb-3">
                <label for="end">End</label>
                <app-date-time-picker id="end" formControlName="end" name="end" [seconds]="false" [disabled]="true"></app-date-time-picker>
                <div class="text-danger" *ngIf="roomClosureForm.get('end').errors?.required">End is required.</div>
                <div class="text-danger" *ngIf="roomClosureForm.get('end')?.value && roomClosureForm.get('end')?.errors?.isValid">End Date must be a valid date.</div>
              </div>
            </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(roomClosureForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
